import axios from '../axios'
import {
    BLOG_LIST_REQUEST, BLOG_LIST_SUCCESS, BLOG_LIST_FAIL,
    BLOG_MINE_REQUEST, BLOG_MINE_SUCCESS, BLOG_MINE_FAIL,
    BLOG_DETAILS_REQUEST, BLOG_DETAILS_SUCCESS, BLOG_DETAILS_FAIL,
    BLOG_CREATE_REQUEST, BLOG_CREATE_SUCCESS, BLOG_CREATE_FAIL,
    BLOG_UPDATE_REQUEST, BLOG_UPDATE_SUCCESS, BLOG_UPDATE_FAIL,
    BLOG_DELETE_REQUEST, BLOG_DELETE_SUCCESS, BLOG_DELETE_FAIL,
} from '../constants/blogConstants'

export const listBlogPosts = () => async (dispatch) => {
    try {
        dispatch({ type: BLOG_LIST_REQUEST })
        const { data } = await axios.get('/api/blog/')
        dispatch({ type: BLOG_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: BLOG_LIST_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}

export const listMyBlogPosts = () => async (dispatch, getState) => {
    try {
        dispatch({ type: BLOG_MINE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        const { data } = await axios.get('/api/blog/mine/', config)
        dispatch({ type: BLOG_MINE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: BLOG_MINE_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}

export const getBlogPost = (id) => async (dispatch) => {
    try {
        dispatch({ type: BLOG_DETAILS_REQUEST })
        const { data } = await axios.get(`/api/blog/${id}/`)
        dispatch({ type: BLOG_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: BLOG_DETAILS_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}

export const createBlogPost = (postData) => async (dispatch, getState) => {
    try {
        dispatch({ type: BLOG_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }
        const formData = new FormData()
        const { image_desktop, image_mobile, ...rest } = postData
        Object.entries(rest).forEach(([key, val]) => {
            if (val !== undefined && val !== null) formData.append(key, val)
        })
        if (image_desktop) formData.append('image_desktop', image_desktop)
        if (image_mobile)  formData.append('image_mobile', image_mobile)
        const { data } = await axios.post('/api/blog/create/', formData, config)
        dispatch({ type: BLOG_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: BLOG_CREATE_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}

export const updateBlogPost = (id, postData) => async (dispatch, getState) => {
    try {
        dispatch({ type: BLOG_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }
        const formData = new FormData()
        const { image_desktop, image_mobile, ...rest } = postData
        Object.entries(rest).forEach(([key, val]) => {
            if (val !== undefined && val !== null) formData.append(key, val)
        })
        if (image_desktop) formData.append('image_desktop', image_desktop)
        if (image_mobile)  formData.append('image_mobile', image_mobile)
        const { data } = await axios.put(`/api/blog/${id}/update/`, formData, config)
        dispatch({ type: BLOG_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: BLOG_UPDATE_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}

export const deleteBlogPost = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: BLOG_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const config = { headers: { Authorization: `Bearer ${userInfo.token}` } }
        await axios.delete(`/api/blog/${id}/delete/`, config)
        dispatch({ type: BLOG_DELETE_SUCCESS })
    } catch (error) {
        dispatch({
            type: BLOG_DELETE_FAIL,
            payload: error.response && error.response.data.detail ? error.response.data.detail : error.message,
        })
    }
}
